import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'
import { HTMLAttributes } from 'react'

import cl from './category-card.module.scss'

interface CategoryCardProps extends HTMLAttributes<HTMLDivElement> {
	link: string
	image: string
	name: string
}

export const CategoryCard = (props: CategoryCardProps) => {
	const { link, image, name, className, ...rest } = props

	return (
		<div className={clsx(cl.root, className)} {...rest}>
			<Link prefetch={false} href={link}>
				<div className={cl.content} title={`Категория ${name}`}>
					<div className={cl.image}>
						<Image src={image} quality={100} alt={`Категория ${name}`} fill />
					</div>
					<p className={cl.name}>{name}</p>
				</div>
			</Link>
		</div>
	)
}
